export default "__VITE_ASSET__C9jyblQP__"